import { MaterialIcon } from '@gorila-shared-ui/components';
import { Button, ButtonOverrides } from 'baseui/button';
import { ButtonGroup } from 'baseui/button-group';
import { useStyles } from '../../hooks/useStyles';
import { useCamera } from './hooks/useCamera';

export function MapControls() {
  const { theme, css } = useStyles();
  const { zoomIn, zoomOut } = useCamera();

  const zoomButtonOverrides: ButtonOverrides = {
    BaseButton: {
      style: {
        width: '22px',
        height: '22px',
      },
    },
  };

  return (
    <span
      className={css({
        position: 'fixed',
        bottom: '64px',
        right: theme.sizing.scale500,
        background: theme.colors.backgroundPrimary,
        boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',
        borderRadius: theme.borders.buttonBorderRadius,
        padding: '3px',
      })}
    >
      <ButtonGroup
        mode="radio"
        size="mini"
        kind="tertiary"
        shape="square"
        overrides={{
          Root: {
            style: {
              flexDirection: 'column',
              margin: 0,
            },
          },
        }}
        onClick={(_, index) => {
          if (index === 0) {
            zoomIn();
          }
          if (index === 1) {
            zoomOut();
          }
        }}
      >
        <Button overrides={zoomButtonOverrides}>
          <MaterialIcon name="add" size="16px" />
        </Button>
        <Button overrides={zoomButtonOverrides}>
          <MaterialIcon name="remove" size="16px" />
        </Button>
      </ButtonGroup>
    </span>
  );
}
